import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Translation } from "@core/locales";
import { Box, List, Prompt, ScrollArea, Stack, Text, Title, factory } from "@coveord/plasma-mantine";
import { Children, isValidElement, useMemo } from "react";
import { Locales } from "../../../strings/Locales.js";
import { DeletePromptList } from "../DeletePromptList.js";
import { DeleteBulkResourcesPromptCancelButton } from "./DeleteBulkResourcesPromptCancelButton.js";
import { DeleteBulkResourcesPromptConfirmButton } from "./DeleteBulkResourcesPromptConfirmButton.js";
export var DeleteBulkResourcesPrompt = factory(function(_param, ref) {
    var additionalDescription = _param.additionalDescription, children = _param.children, onClose = _param.onClose, opened = _param.opened, resourceNames = _param.resourceNames, resourceType = _param.resourceType, promptProps = _object_without_properties(_param, [
        "additionalDescription",
        "children",
        "onClose",
        "opened",
        "resourceNames",
        "resourceType"
    ]);
    var normalizedResourceNames = resourceNames.map(function(name) {
        return name.trim();
    });
    var promptButtons = useMemo(function() {
        return Children.toArray(children).filter(function(child) {
            return /*#__PURE__*/ isValidElement(child) && (child.type === DeleteBulkResourcesPromptCancelButton || child.type === DeleteBulkResourcesPromptConfirmButton);
        });
    }, [
        children
    ]);
    return /*#__PURE__*/ _jsxs(Prompt, _object_spread_props(_object_spread({
        title: Locales.format("DeleteBulkResourcesPrompt.title", {
            resourceType: resourceType
        }),
        variant: "critical",
        opened: opened,
        onClose: onClose,
        ref: ref
    }, promptProps), {
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                gap: "sm",
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        children: /*#__PURE__*/ _jsx(Translation, {
                            t: Locales,
                            i18nKey: "DeleteBulkResourcesPrompt.description.default",
                            options: {
                                smart_count: normalizedResourceNames.length,
                                resourceType: resourceType
                            },
                            children: /*#__PURE__*/ _jsx(Text, {
                                inherit: true,
                                span: true,
                                fw: 500
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Stack, {
                        gap: "xs",
                        children: [
                            /*#__PURE__*/ _jsx(Title, {
                                order: 5,
                                children: Locales.format("DeleteBulkResourcesPrompt.description.list.title", {
                                    resourceType: resourceType,
                                    resourceCount: normalizedResourceNames.length
                                })
                            }),
                            /*#__PURE__*/ _jsx(ScrollArea.Autosize, {
                                mah: 240,
                                offsetScrollbars: "y",
                                children: /*#__PURE__*/ _jsx(DeletePromptList, {
                                    children: normalizedResourceNames.map(function(name, ix) {
                                        return /*#__PURE__*/ _jsx(List.Item, {
                                            children: name
                                        }, "resource-".concat(ix));
                                    })
                                })
                            })
                        ]
                    }),
                    additionalDescription && /*#__PURE__*/ _jsx(Box, {
                        "data-testid": "delete-bulk-resources-prompt-additional-description",
                        children: additionalDescription
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Prompt.Footer, {
                children: promptButtons
            })
        ]
    }));
});
DeleteBulkResourcesPrompt.CancelButton = DeleteBulkResourcesPromptCancelButton;
DeleteBulkResourcesPrompt.ConfirmButton = DeleteBulkResourcesPromptConfirmButton;
DeleteBulkResourcesPrompt.displayName = "DeleteBulkResourcesPrompt";

//# sourceMappingURL=DeleteBulkResourcesPrompt.js.map